import React from 'react';
import './Ticker.css';

const Ticker = () => {
  const phrases = [
    "Вы больше не захотите нанимать людей",
    "Продажи — гонка, а ваш бизнес — машина",
    "Пока другие переключают передачи вручную, вы можете поставить \"автомат\" и ехать быстрее"
  ];

  return (
    <div className="ticker-wrapper bg-gradient-to-r from-gray-100 via-gray-200 to-gray-100 py-4 overflow-hidden border-y border-gray-300">
      <div className="ticker">
        <div className="ticker-content">
          {[...Array(3)].map((_, index) => (
            <div key={index} className="ticker-items flex items-center">
              {phrases.map((phrase, i) => (
                <React.Fragment key={i}>
                  <span className="ticker-item text-gray-700 font-semibold text-base mx-8">
                    {phrase}
                  </span>
                  <span className="ticker-separator text-gray-500 mx-4">•</span>
                </React.Fragment>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Ticker;
